export default "__VITE_ASSET__BS1v4aU7__"